import { ViewController } from '@estee/elc-service';
import { observable, computed } from 'mobx';
import { diContainer } from '../../service-setup/diContainer';
import serviceNames from '~setup/CommunicationsService';
import { EmailOptInRepository } from '../repositories/EmailOptInRepository';

export class ViewEmailOptInViewController extends ViewController {
    @observable private emailOptInRepository: EmailOptInRepository;

    constructor() {
        super();
        this.emailOptInRepository = diContainer.get(serviceNames.emailOptInRepository);
    }

    @computed
    public get data() {
        return {
            emailOptIn: this.isEmailSubscribed
        };
    }

    @computed
    get emailOptIn() {
        return this.emailOptInRepository.emailOptInResponse;
    }

    @computed
    get isLoaded() {
        return this.emailOptIn;
    }

    @computed
    public get isEmailSubscribed() {
        return this.emailOptIn ? this.emailOptIn.emailSubscribed : false;
    }
}
